import '../scss/social.scss';

function SocialButton() {
  return (
    <nav>
    <ul className='socialBox'>
     <li><a
          href="https://www.facebook.com/profile.php?id=100091085139578"
          target="_blank"
          rel="noopener noreferrer" className="socialText"
        >
        <img src="./assets/icon-image/facebkicon.png" alt="FaceBook" className='infoSocialIcon'/></a>
     </li>
     <li hidden='hidden'><a
          href="/"
          target="_blank"
          rel="noopener noreferrer"  className="socialText"
        >
        <img src="./assets/icon-image/twitter.png" alt="Twitter" className='infoSocialIcon'/></a>
     </li>
     <li><a
          href="https://www.instagram.com/myvisapriority/"
          target="_blank"
          rel="noopener noreferrer"  className="socialText"
        >
        <img src="./assets/icon-image/insta.png" alt="instagram" className='infoSocialIcon'/></a>
    </li>
     <li><a
          href="https://www.linkedin.com/company/myvisapriority-com/"
          target="_blank"
          rel="noopener noreferrer"  className="socialText"
        >
        <img src="./assets/icon-image/linkedin.png" alt="linkedin" className='infoSocialIcon'/></a>
    </li>
    <li><a
          href="https://wa.me/+971503096788"
          target="_blank"
          rel="noopener noreferrer"  className="socialText"
        >
        <img src="./assets/icon-image/waicons.png" alt="WhatsApp" className='infoSocialIcon'/></a>
    </li>
    <li hidden='hidden'><a
          href="/"
          target="_blank"
          rel="noopener noreferrer"  className="socialText"
        >
        <img src="./assets/icon-image/youtube.png" alt="youtube" className='infoSocialIcon'/></a>
    </li>
    </ul>
  </nav>
  )
}

export default SocialButton